import type { SortKey, SortState } from './customers';

/**
 * A column header that sorts the table. The <th> carries aria-sort so
 * assistive technology announces the current order; the button cycles
 * ascending → descending → route order.
 */
export function SortableHeader({
  column,
  label,
  sortLabel = label,
  sort,
  onSort,
  className,
}: {
  column: SortKey;
  label: string;
  /** What the sort is called in the tooltip when the header reads differently. */
  sortLabel?: string;
  sort: SortState | null;
  onSort: (key: SortKey) => void;
  className?: string;
}) {
  const active = sort?.key === column;
  const direction = active ? sort.direction : 'none';
  const indicator = direction === 'ascending' ? '▲' : direction === 'descending' ? '▼' : '↕';
  const hint =
    direction === 'none'
      ? `Sort by ${sortLabel}`
      : direction === 'ascending'
        ? `Sorted by ${sortLabel}, A to Z. Click to reverse.`
        : `Sorted by ${sortLabel}, Z to A. Click for route order.`;
  return (
    <th scope="col" aria-sort={direction} className={className}>
      <button type="button" className="sort-header" onClick={() => onSort(column)} title={hint}>
        {label}
        <span className="sort-indicator" aria-hidden="true">
          {indicator}
        </span>
      </button>
      <span className="sort-print-label">{label}</span>
    </th>
  );
}
